import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ImageComponent, ImageThumb } from './styles';

const Empty = styled.div`
	position: absolute;
	top: 0px;
	left: 0px;

	width: 100%;
	height: 100%;

	background-color: rgba(240,240,240,1);
`;
const layoutStyles = {
	default: [
		[], // 0 images
		[ // 1 image
			{ top: 0, left: 0, width: 100, height: 100 },
		],
		[ // 2 images
			{ top: 5, left: 5, width: 42.5, height: 90 },
			{ top: 5, left: 52.5, width: 42.5, height: 90 },
		],
		[ // 3 images
			{ top: 5, left: 5, width: 42.5, height: 90 },
			{ top: 5, left: 52.5, width: 42.5, height: 42.5 },
			{ top: 52.5, left: 52.5, width: 42.5, height: 42.5 },
		],
		[ // 4 images
			{ top: 5, left: 5, width: 42.5, height: 42.5 },
			{ top: 5, left: 52.5, width: 42.5, height: 42.5 },
			{ top: 52.5, left: 5, width: 42.5, height: 42.5 },
			{ top: 52.5, left: 52.5, width: 42.5, height: 42.5 },
		],
	],
	b: [
		[],
		[ // 1 image
			{ top: 0, left: 0, width: 100, height: 100 },
		],
		[ // 2 images
			{ top: 5, left: 5, width: 90, height: 42.5 },
			{ top: 52.5, left: 5, width: 90, height: 42.5 },
		],
		[ // 3 images
			{ top: 5, left: 5, width: 42.5, height: 42.5 },
			{ top: 5, left: 52.5, width: 42.5, height: 90 },
			{ top: 52.5, left: 5, width: 42.5, height: 42.5 },
		],
		[ // 4 images
			{ top: 5, left: 5, width: 40, height: 90 },
			{ top: 5, left: 52.5, width: 42.5, height: 40 },
			{ top: 55, left: 52.5, width: 20, height: 40 },
			{ top: 55, left: 75, width: 20, height: 40 },
		],
	],
	c: [
		[],
		[ // 1 image
			{ top: 0, left: 0, width: 100, height: 100 },
		],
		[ // 2 images
			{ top: 5, left: 5, width: 90, height: 50 },
			{ top: 60, left: 5, width: 90, height: 35 },
		],
		[ // 3 images
			{ top: 5, left: 5, width: 90, height: 40 },
			{ top: 55, left: 5, width: 40, height: 40 },
			{ top: 55, left: 55, width: 40, height: 40 },
		],
		[ // 4 images
			{ top: 5, left: 5, width: 90, height: 40 },
			{ top: 55, left: 5, width: 25, height: 40 },
			{ top: 55, left: 35, width: 30, height: 40 },
			{ top: 55, left: 70, width: 25, height: 40 },
		],
	]
}

const Image = ({ data, layout }) => {
	const layoutIndex = Math.min(4, data.slice(0,4).length);
	const layoutStyle = layoutStyles[layout][layoutIndex];
	const images = data.slice(0,4).map((image, imageIndex) => {
		const style = layoutStyle[imageIndex];

		return (
			<ImageThumb
				key={image.file}
				positionX={image.position[0]}
				positionY={image.position[1]}
				size={image.size}
				url={image.url}
				{...style}
			/>
		)
	});

	return (
		<ImageComponent>
			{
				data.length === 0 ?
					<Empty /> :
					images
			}
		</ImageComponent>
	)
}

Image.propTypes = {
	data: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object
	]),
	layout: PropTypes.string,
}

export default Image
